import { db, getCollectionName } from "../firebase"
import { collection, getDocs, query, orderBy, doc, getDoc, startAfter, limit } from "firebase/firestore"

const PAGE_SIZE = 10

export const fetchInventory = async ({ pageParam }) => {
    try {
        let q
        if (pageParam) {
            q = query(
                collection(db, getCollectionName("inventory")),
                orderBy("departureDate", "desc"),
                startAfter(pageParam),
                limit(PAGE_SIZE)
            )
        } else {
            q = query(
                collection(db, getCollectionName("inventory")),
                orderBy("departureDate", "desc"),
                limit(PAGE_SIZE)
            )
        }

        const snapshot = await getDocs(q)
        const lastVisible = snapshot.docs[snapshot.docs.length - 1]

        // Only return hasMore: true if we got a full page of results
        const hasMore = snapshot.docs.length === PAGE_SIZE

        return {
            items: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            lastVisible: lastVisible,
            hasMore
        }
    } catch (error) {
        console.error("Error fetching inventory:", error)
        throw error
    }
}

export const fetchFlights = async ({ pageParam, loadAll = false } = {}) => {
    try {
        let q
        if (loadAll) {
            // Return all flights without pagination
            q = query(
                collection(db, getCollectionName("flights")),
                orderBy("flightNo", "asc")
            )
        } else if (pageParam) {
            q = query(
                collection(db, getCollectionName("flights")),
                orderBy("flightNo", "asc"),
                startAfter(pageParam),
                limit(PAGE_SIZE)
            )
        } else {
            q = query(
                collection(db, getCollectionName("flights")),
                orderBy("flightNo", "asc"),
                limit(PAGE_SIZE)
            )
        }

        const snapshot = await getDocs(q)

        if (loadAll) {
            // Return all flights as items array
            return {
                items: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
                lastVisible: null,
                hasMore: false
            }
        }

        const lastVisible = snapshot.docs[snapshot.docs.length - 1]
        // Only return hasMore: true if we got a full page of results
        const hasMore = snapshot.docs.length === PAGE_SIZE

        return {
            items: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            lastVisible: lastVisible,
            hasMore
        }
    } catch (error) {
        console.error("Error fetching flights:", error)
        throw error
    }
}

export const fetchAirports = async () => {
    try {
        const airportsCollection = collection(db, getCollectionName("airports"))
        const snapshot = await getDocs(airportsCollection)
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    } catch (error) {
        console.error("Error fetching airports:", error)
        throw error
    }
}

// Add this new function
export const checkFlightNoExists = async (flightNo) => {
    try {
        const docRef = doc(db, getCollectionName("flights"), flightNo)
        const docSnap = await getDoc(docRef)
        return docSnap.exists()
    } catch (error) {
        console.error("Error checking flight number:", error)
        throw error
    }
}

export const fetchPromos = async () => {
    try {
        const promosCollection = collection(db, getCollectionName("promos"))
        const q = query(promosCollection, orderBy("expirationDate", "desc"))
        const snapshot = await getDocs(q)
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    } catch (error) {
        console.error("Error fetching promos:", error)
        throw error
    }
}

export const checkPromoExists = async (code) => {
    try {
        const docRef = doc(db, getCollectionName("promos"), code)
        const docSnap = await getDoc(docRef)
        return docSnap.exists()
    } catch (error) {
        console.error("Error checking promo code:", error)
        throw error
    }
}

export const fetchBookings = async ({ pageParam }) => {
    try {
        let q
        if (pageParam) {
            q = query(
                collection(db, getCollectionName("bookings")),
                orderBy("dateAdded", "desc"),
                startAfter(pageParam),
                limit(PAGE_SIZE)
            )
        } else {
            q = query(
                collection(db, getCollectionName("bookings")),
                orderBy("dateAdded", "desc"),
                limit(PAGE_SIZE)
            )
        }

        const snapshot = await getDocs(q)
        const lastVisible = snapshot.docs[snapshot.docs.length - 1]

        // Only return hasMore: true if we got a full page of results
        const hasMore = snapshot.docs.length === PAGE_SIZE

        return {
            items: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            lastVisible: lastVisible,
            hasMore
        }
    } catch (error) {
        console.error("Error fetching bookings:", error)
        throw error
    }
}

export const fetchFlightById = async (flightId) => {
    const docRef = doc(db, getCollectionName("inventory"), flightId);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) return null;
    return { id: docSnap.id, ...docSnap.data() };
};